export default __webpack_public_path__ + "static/media/Tech_Blog_homepage.f3f2469d.png";